module.exports = __webpack_public_path__ + "plugins/web/img/std_ask.ca7aaf9e.png";